import { notificationConstants } from '../_constants';

//-- get the list of notification
export function getNotificationsList(state = {}, action) {
  switch (action.type) {
    case notificationConstants.NOTIFICATION_LIST_REQUEST:
      return {
        getNotificationsList: false
      };

    case notificationConstants.NOTIFICATION_LIST_SUCCESS:
      console.log("ASC ", action.user);
      return { isGetNotificationList: true, getNotificationsList: action.successAction };

    case notificationConstants.NOTIFICATION_LIST_FAILURE:
      return {
        getNotificationsList: false,
      };

    case notificationConstants.NOTIFICATION_SEARCH_REQUEST:
      return { isGetNotificationList: true, getNotificationsList: action.successAction.data };

    default:
      return state
  }
}


//-- get the list of notification
export function getUserNotificationsList(state = {}, action) {
  switch (action.type) {
    case notificationConstants.USERS_NOTIFICATION_LIST_REQUEST:
      return {
        getUserNotificationsList: false
      };

    case notificationConstants.USERS_NOTIFICATION_LIST_SUCCESS:
      console.log("ASC ", action.user);
      return { isGetNotificationList: true, getUserNotificationsList: action.successAction };

    case notificationConstants.USERS_NOTIFICATION_LIST_FAILURE:
      return {
        getUserNotificationsList: false,
      };

    default:
      return state
  }
}


//-- get the list of notification for shopkeeper on bell
export function getUserBellNotificationsList(state = {}, action) {
  switch (action.type) {
    case notificationConstants.USERS_BELL_NOTIFICATION_LIST_REQUEST:
      return {
        getUserBellNotificationsList: false
      };

    case notificationConstants.USERS_BELL_NOTIFICATION_LIST_SUCCESS:
      return { isGetNotificationList: true, getUserBellNotificationsList: action.successAction };

    case notificationConstants.USERS_BELL_NOTIFICATION_LIST_FAILURE:
      return {
        getUserBellNotificationsList: false,
      };

    default:
      return state
  }
}




//-- get the list of notification for shopkeeper on bell
export function sentUserEmailNotifications(state = {}, action) {
  switch (action.type) {
    case notificationConstants.SENT_NOTIFICATION_LIST_REQUEST:
      return {
        sentUserEmailNotifications: false
      };

    case notificationConstants.SENT_NOTIFICATION_LIST_SUCCESS:
      return { sentUserEmailNotifications: true };

    case notificationConstants.SENT_NOTIFICATION_LIST_ERROR:
      return {
        sentUserEmailNotifications: false,
      };

    default:
      return state
  }
}
